
    <div class="container py-64 min-h-100vh">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="tm-card card-404">
            <div class="card-body">
              <div class="content-wrapper">
                <div class="img-wrapper">
                  <img src="/assets/media/404.png" alt="404 Picture" width="182" height="157">
                </div>
                <div class="content-title">
                  <h2>خطأ في الوصول للصفحة</h2>
                  <p>قد تكون الصفحة قيد التطوير أو تم حذفها</p>
                </div>
                <div class="content-actions">
                  <button type="button" class="btn tm-btn btn-primary"
                  (click)="goToHome()">العودة إلى الرئيسية</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    